import { request } from '@/shared/api/request'

export const getDistricts = (params) => {
	return request({ url: 'dict/kato', method: 'GET', params })
}
